/* eslint-disable import/no-anonymous-default-export */
import axios, { Axios, AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { serialize } from 'object-to-formdata';
import UsuariosContext from "../../common/contexts/UsuariosContext";
import { useContext } from 'react';

export interface Model {
    Id: number
    CreatedAt: Date
    UpdatedAt: Date
    DeletedAt?: Date
    IsDeleted: Boolean
}


export interface Response<T> {
    "@odata.count"?: number
    value: T
}

export interface ActionResult<T> {
    data?: Response<T>
    error?: Error | AxiosError
}


export interface Query {
    $count?: boolean
    $top?: number
    $skip?: number
    $expand?: string[]
    $orderby?: string[]
    $filter?: string[]
    $apply?: string[]
    $select?: string[]
}

export interface ApiProps {
    module: string
}
export type Api =
    {
        baseAxiosConfig: AxiosRequestConfig
        axiosInstance: AxiosInstance
        list: <TResponse>(query?: Query, extraQs?: string[], path?:string) => Promise<ActionResult<TResponse[]>>
        save: <TData extends Partial<Model>, TResponse>(data: TData, putForUpdate?: boolean, getFormDataFn?:(data:TData)=>FormData) => Promise<ActionResult<TResponse>>
        delete: <TResponse>(id: number) => Promise<ActionResult<TResponse>>
        count: (query?: Query, extraQs?: string[]) => Promise<ActionResult<number>>,
        queryToString: (query: Query) => string
        getFormData: (data: object) => FormData
    }




export default (props: ApiProps): Api => {
    const usersContext = useContext(UsuariosContext);
    const baseURL = process.env.REACT_APP_API_URL;
    const baseAxiosConfig = {
        baseURL,
        headers: {
            "Authorization": `bearer ${localStorage.getItem("_token")}`,
            "X-ClientId": `${process.env.REACT_APP_CLIENT_ID_HEADER ?? ""}`,
        }
    };
    const axiosInstance = axios.create(baseAxiosConfig)


    const queryToString = (query: Query) => {
        let qs: string[] = [];

        if (query.$count) {
            qs.push("$count=true");
        }
        if (query.$expand && query.$expand.length) {
            qs.push(`$expand=${query.$expand.join(",")}`);
        }
        if (query.$skip) {
            qs.push(`$skip=${query.$skip}`);
        }
        if (query.$top != undefined) {
            qs.push(`$top=${query.$top}`);
        }

        if (!query.$orderby || query.$orderby.length == 0) {
            query.$orderby = ['Id asc'];
        }
        qs.push(`$orderby=${query.$orderby.join(",")}`)

        /* const equiposMunicipio = usersContext.user!.identificadoresEquipoJuzgado;
        const isNotNull = equiposMunicipio?.every(e => e !== null);
        if (equiposMunicipio?.length !== 0 &&  isNotNull) {
            query.$filter?.push(`EquipoId in(${equiposMunicipio})`);
        }   */

        if (query.$filter && query.$filter.length > 0) {                      
            qs.push(`$filter=${query.$filter.join(" and ")}`);            
        }

        if (query.$apply != undefined && query.$apply.length > 0) {
            qs.push(`$apply=${query.$apply.join("/")}`);
        }

        if(query.$select != undefined && query.$select.length > 0)
        {
            qs.push(`$select=${query.$select.join(",")}`)
        }

        return qs.join("&");

    };

    const getFormData = (data: any) => {
        const formData = serialize(data, {indices:true});

        return formData;


        /*
        for (const key in data) {
            const value: any = data[key];

            if (value == undefined) {
                continue;
            }
            if (value instanceof File) {
                formData.append(key, value);
            }
            else if(value.constructor == [].constructor)
            {
                for(const index in value)
                {
                    if (value.constructor == {}.constructor)
                    {

                    }
                    else
                    {
                        
                    }
                }
            }
            else if (value.constructor == {}.constructor) {
                formData.append(key, JSON.stringify(value));
            }
            else {
                formData.append(key, data[key].toString());

            }
        }

        return formData;*/
    };

    return {
        baseAxiosConfig,
        axiosInstance,
        queryToString,
        getFormData,
        async list<TResponse>(query?: Query, extraQuery?: string[], path?:string) {

            let qs = queryToString(query ?? {});
            if (extraQuery && extraQuery.length) {
                qs += `&${extraQuery.join("&")}`;
            }
            try {
                const url = path ? `${props.module}/${path}?${qs}` : `${props.module}?${qs}`
                const response = await axiosInstance.get<Response<TResponse[]>>(url);
                return {
                    data: response.data.value ? response.data : { value: (response.data as any) }
                };
            }
            catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        async save<TData extends Partial<Model>, TResponse>(data: TData, putForUpdate?: boolean, getFormDataFn?:(data:TData)=>FormData) {
            try {
                const url = data.Id ? `${props.module}/${data.Id}` : `${props.module}`;
                const headers:any = {};
                let dataToSend: TData | FormData = data;

                if (getFormDataFn)
                {
                    headers["Content-Type"] = "multipart/form-data";
                    dataToSend = getFormDataFn(data);
                }
                const response = await axiosInstance.request<Response<TResponse>>({
                    method: data.Id ? (putForUpdate ? "PUT" : "PATCH") : "POST",
                    data:dataToSend,
                    url,
                    headers
                });
                return {
                    data: response.data,
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        async delete<TResponse>(id: number) {
            try {

                const response = await axiosInstance.request<Response<TResponse>>({
                    method: "DELETE",
                    url: `${props.module}/${id}`
                });
                return {

                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        async count(query?: Query, extraQuery?: string[]) {
            const q = query ?? {};
            q.$count = true;
            q.$top = 0;

            let qs = queryToString(q);
            if (extraQuery && extraQuery.length) {
                qs += `&${extraQuery.join("&")}`;
            }
            try {
                const response = await axiosInstance.get<Response<any>>(`${props.module}?${qs}`);
                return {
                    data: {
                        value: response.data['@odata.count'] ?? 0
                    }
                };
            }
            catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        }
    }
};